import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p><strong>Last Updated: 4th February, 2025</strong></p>
      <p>
        This Privacy Policy explains how SlayD ("we," "us," or "our") collects, uses, shares, and protects information about users of our application (the "App") that integrates with the Pinterest Developer Program. By using the App, you agree to the terms of this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information when you use our App:</p>

      <h3>1.1 Information Provided by You</h3>
      <ul>
        <li><strong>Pinterest Account Information:</strong> When you connect your Pinterest account to our App, we may collect information such as your Pinterest username, profile information, email address, and boards.</li>
        <li><strong>User Content:</strong> If you choose to share pins or boards with our App, we may collect and store that content.</li>
        <li><strong>Contact Information:</strong> If you provide it, we may collect your name, email address, or other contact details.</li>
      </ul>

      <h3>1.2 Information Collected Automatically</h3>
      <ul>
        <li><strong>Usage Data:</strong> We may collect information about how you interact with the App, such as the features you use and the time spent on the App.</li>
        <li><strong>Device Information:</strong> We may collect information about the device you use to access the App, including the device type, operating system, and browser type.</li>
        <li><strong>Log Data:</strong> We may collect server logs, including your IP address, access times, and referring URLs.</li>
      </ul>

      <h3>1.3 Information from Pinterest</h3>
      <p>
        Through the Pinterest API, we may receive additional information about you or your Pinterest account, as permitted by Pinterest's Developer Terms and Privacy Policy. This includes:
      </p>
      <ul>
        <li>Pins and boards you share with us.</li>
        <li>Updates to your boards, such as new posts added to shared boards.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect for the following purposes:</p>
      <ul>
        <li>To enable Pinterest integrations, such as allowing you to share pins and boards with our App.</li>
        <li>To fetch and display posts from the boards you share with us.</li>
        <li>To automatically fetch new posts added to your shared boards.</li>
        <li>To improve the functionality and user experience of the App.</li>
        <li>To communicate with you, including responding to your inquiries and sending updates about the App.</li>
        <li>To comply with legal obligations and enforce our terms of service.</li>
      </ul>

      <h2>3. How We Share Your Information</h2>
      <p>We may share your information in the following circumstances:</p>
      <ul>
        <li><strong>With Pinterest:</strong> We may share information with Pinterest as necessary to provide the App and comply with Pinterest's Developer Terms.</li>
        <li><strong>With Service Providers:</strong> We may share information with third-party service providers (e.g., hosting providers, analytics services) who assist us in operating the App. These providers are contractually obligated to protect your data and use it only for the purposes we specify.</li>
        <li><strong>For Legal Reasons:</strong> We may disclose information if required by law, such as to comply with a subpoena or similar legal process.</li>
        <li><strong>With Your Consent:</strong> We may share information with third parties if you give us explicit permission to do so.</li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>
        We retain your information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
      </p>

      <h2>5. Your Rights and Choices</h2>
      <p>As a user, you have the following rights regarding your personal information:</p>
      <ul>
        <li><strong>Access:</strong> You can request access to the personal information we hold about you.</li>
        <li><strong>Correction:</strong> You can request that we correct or update your information.</li>
        <li><strong>Deletion:</strong> You can request that we delete your information.</li>
        <li><strong>Opt-Out:</strong> You can opt out of certain data collection or processing activities, including online behavioral advertising.</li>
      </ul>
      <p>
        To exercise these rights, please contact us at <a href="mailto:slaydapp@gmail.com">slaydapp@gmail.com</a>.
      </p>

      <h2>6. Data Security</h2>
      <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure. These measures include:</p>
      <ul>
        <li><strong>Encryption:</strong> Data is encrypted during transmission and storage.</li>
        <li><strong>Access Controls:</strong> Only authorized personnel have access to user data.</li>
        <li><strong>Regular Audits:</strong> We conduct regular security audits to ensure data protection.</li>
      </ul>

      <h2>7. Third-Party Links and Services</h2>
      <p>
        Our App may contain links to third-party websites or services. This Privacy Policy does not apply to those third parties, and we are not responsible for their practices. We encourage you to review their privacy policies.
      </p>

      <h2>8. Children’s Privacy</h2>
      <p>
        Our App is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.
      </p>

      <h2>9. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. If we make material changes, we will notify you by posting the updated policy on our website or through other communication methods.
      </p>

      <h2>10. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>
      <ul>
        <li>SlayD</li>
        <li>Email: <a href="mailto:slaydapp@gmail.com">slaydapp@gmail.com</a></li>
        <li>Phone: +91-8003547411</li>
      </ul>

      <h2>11. Pinterest Developer Program Compliance</h2>
      <p>
        This Privacy Policy is designed to comply with Pinterest's Developer Terms and Privacy Policy. By using our App, you also agree to Pinterest's terms and policies.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        This Privacy Policy is governed by the laws of India. Any disputes arising out of or related to this Privacy Policy shall be subject to the exclusive jurisdiction of the courts located in Gurgaon, Haryana, India.
      </p>

      <h2>13. Consent for Data Collection and Usage</h2>
      <p>
        By using our App, you consent to the collection, use, and sharing of your information as described in this Privacy Policy. If we collect sensitive information or use your data for purposes beyond what is described here, we will obtain your explicit consent.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
